import axios from 'axios'
import store from '@/store'

export const networkService = {

  token() {
    return store.state.authentication.token
  },

  apiUrl() {
    return store.state.baseApiUrl
  },

  headers() {
    let headers = {Accept: 'application/json', 'Content-Type': 'application/json'}
    if (store.state.authentication.isAuthenticated) headers['Authorization'] = `Bearer ${this.token().accessToken}`

    return headers
  },

  get(url) {
    if (!url.startsWith('/')) {
      url = `/${url}`
    }
    return new Promise((resolve, reject) => {

      axios
        .get(`${this.apiUrl()}${url}`, {headers: this.headers()})
        .then(this.handleStatusCode)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  post(url, body) {
    if (!url.startsWith('/')) {
      url = `/${url}`
    }
    return new Promise((resolve, reject) => {
      axios
        .post(`${this.apiUrl()}${url}`, body, {headers: this.headers()})
        .then(this.handleStatusCode)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  put(url, body) {
    if (!url.startsWith('/')) {
      url = `/${url}`
    }
    return new Promise((resolve, reject) => {
      axios
        .put(`${this.apiUrl()}${url}`, body, {headers: this.headers()})
        .then(this.handleStatusCode)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  delete(url) {
    if (!url.startsWith('/')) {
      url = `/${url}`
    }
    return new Promise((resolve, reject) => {
      axios
        .delete(`${this.apiUrl()}${url}`, {headers: this.headers()})
        .then(this.handleStatusCode)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  download(url) {
    window.open(`${this.apiUrl()}${url}`)
  },

  handleStatusCode(res) {
    switch (res.status) {
      case 400:
        throw new Error('Bad Request')
      case 401:
        throw new Error('Unauthorized')
      case 404:
        throw new Error('Endpoint not found (404)')
      default:
        return res
    }
  },
}
